import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

export const getAdminReportingData = async (
  pageNum,
  filters,
  searchString,
  pageSize,
  viewType,
  sortField,
  sortOrder
) => {
  try {
    const res = await API.get_admin_reporting_data(
      pageNum,
      filters,
      searchString,
      pageSize,
      viewType,
      sortField,
      sortOrder
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const reportingProcess = async (id) => {
  try {
    const res = await API.reprocess_csv(id);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};


export const getDemandPartnerList = async () => {
  try {
    const res = await API.get_demand_partner_list();
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
   }
};